import {makeVar} from "@apollo/client";

const userId = makeVar(undefined)

export {userId}